export const uploadKinds = ["landing-image", "landing-video", "downloadable-file", "course-page-attachment"] as const

export type UploadKind = (typeof uploadKinds)[number]

const MB = 1024 * 1024

/** Enforced by the API when preparing an upload; clients check it first to reject oversized files up front. */
export const uploadMaxBytes = {
	"landing-image": 12 * MB,
	"landing-video": 400 * MB,
	"downloadable-file": 200 * MB,
	"course-page-attachment": 200 * MB,
} satisfies Record<UploadKind, number>

/**
 * Shared with the `clean-uploads` task, which garbage collects every one of these directories. A path that
 * only exists in the API is a path nothing ever cleans up.
 */
export const uploadPaths = {
	bundle: { thumbnail: "uploads/bundles/thumbnails" },
	course: {
		thumbnail: "uploads/courses",
		longDescription: {
			image: "uploads/courses/long-description/images",
		},
	},
	coursePage: {
		image: "uploads/pages/images",
		audio: "uploads/pages/audio",
		attachments: "uploads/pages/attachments",
	},
	communityPost: { image: "uploads/community/posts/images", attachment: "uploads/community/posts/attachments" },
	communityProfile: { avatar: "uploads/community/avatars" },
	downloadable: {
		file: "uploads/downloadables/files",
		thumbnail: "uploads/downloadables/thumbnails",
	},
	event: { thumbnail: "uploads/events/thumbnails" },
	membership: { thumbnail: "uploads/memberships/thumbnails" },
	landing: { image: "uploads/landing/images", video: "uploads/landing/videos" },
	platform: {
		logo: "uploads/platforms/logos",
		favicon: "uploads/platforms/favicons",
		thumbnail: "uploads/platforms/thumbnails",
	},
	privateSession: { thumbnail: "uploads/sessions/thumbnails" },
	temp: "uploads/temp",
} as const
